var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-toggle",on:{"click":_vm.toggleTheme}},[_c('div',{staticClass:"toggle-track",class:{ dark: _vm.isDark }},[_c('div',{staticClass:"toggle-thumb"},[_c('i',{class:_vm.isDark ? 'pi pi-moon p-fs-n' : 'pi pi-sun'})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }